module.exports = __webpack_public_path__ + "static/img/magnifier.6693133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portal/magnifier.png
// module id = ggZ7
// module chunks = 32